export const name = 'AlertDialogController';

export default function AlertDialogController($mdDialog) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  var vm = this;
  vm.close = close;
  vm.reject = cancel;

  return;

  function close() {
    $mdDialog.hide();
  }

  function cancel() {
    $mdDialog.cancel();
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/alert-dialog/alert-dialog.controller.js